export default __webpack_public_path__ + "static/media/PASSENGERS_BY_TERMINAL.15594ce3.svg";